export { default, type TextContentProps } from './TextContent';
